import { useEffect, useRef, useState } from "react";
import { useTheme } from "./hooks/useTheme";

type Props = {
    list: any[];
    selectedItem: any | null;
    setSelectedItem: (value: any | null) => void;
}

export default function Dropdown({
    list,
    selectedItem,
    setSelectedItem
}: Props) {
    const { theme, themeStyles } = useTheme();
    const [open, setOpen] = useState<boolean>(false);
    const dropdownRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleDropDown = (e: Event) => {
            if (!dropdownRef.current?.contains(e.target as Node)) setOpen(false);
        }

        document.addEventListener("click", handleDropDown);
        return () => document.removeEventListener("click", handleDropDown);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            ref={dropdownRef}
            className="relative w-[220px]"
        >
            {/* Button */}
            <button
                type="button"
                onClick={() => setOpen(!open)}
                className={`w-full flex items-center justify-between py-[6px] px-[8px] gap-2 rounded-lg border ${themeStyles.topBar.tailwindBorderColor}`}
            >
                <span
                    className={`${themeStyles.topBar.tailwindTextColor} text-[14px] font-medium line-clamp-1`}
                    title={selectedItem?.label}
                >
                    {selectedItem?.label}
                </span>

                <span className={`material-symbols-outlined ${themeStyles.topBar.tailwindTextColor} text-[22px]`}>
                    {open ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                </span>
            </button>

            {/* Dropdown */}
            {
                open && (
                    <div
                        className={`absolute z-50 mt-1 w-full rounded-lg border shadow-md max-h-[240px] overflow-y-auto ${themeStyles.topBar.tailwindBorderColor}`}
                        style={{ backgroundColor: themeStyles.topBar.bg }}
                    >
                        {
                            list?.map((item, index) => (
                                <div
                                    key={index}
                                    onClick={() => {
                                        setSelectedItem(item);
                                        setOpen(false);
                                    }}
                                    className={`px-3 py-2 cursor-pointer ${theme === "dark" ? "hover:bg-white/10" : "hover:bg-black/10"}`}
                                >
                                    {/* Wrap long names nicely */}
                                    <p
                                        className={`${themeStyles.topBar.tailwindTextColor} text-[14px] font-medium break-words`}
                                        title={item?.label}
                                    >
                                        {item?.label}
                                    </p>
                                </div>
                            ))
                        }
                    </div>
                )
            }
        </div>
    );
}
